<fb-page-header [title]="'CUSTOMERS' | translate" [subtitle]="'CUSTOMERS_SUBTITLE' | translate" />

<section class="grid grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
    <fb-stat-card [label]="'TOTAL_CUSTOMERS' | translate" [value]="loading() ? '–' : stats().total" icon="ph-users" />
    <fb-stat-card [label]="'MULTI_VENUE_CUSTOMERS' | translate" [value]="loading() ? '–' : stats().multiVenue" icon="ph-buildings" />
    <fb-stat-card [label]="'COMPANY_CUSTOMERS' | translate" [value]="loading() ? '–' : stats().companies" icon="ph-briefcase" />
    <fb-stat-card [label]="'BLOCKED_CUSTOMERS' | translate" [value]="loading() ? '–' : stats().blocked" icon="ph-prohibit" />
</section>

<section class="rounded-md bg-surface border border-border overflow-hidden">
    <div class="flex flex-wrap items-center justify-between gap-3 p-4 border-b border-border">
        <p-iconfield class="w-full max-w-sm">
            <p-inputicon class="ph ph-magnifying-glass" />
            <input
                pInputText
                type="search"
                class="w-full"
                [placeholder]="'SEARCH_CUSTOMERS' | translate"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)" />
        </p-iconfield>
        <p-selectbutton [options]="filterOptions" optionValue="value" [ngModel]="filter()" (ngModelChange)="filter.set($event ?? 'ALL')" [allowEmpty]="false">
            <ng-template #item let-option>{{ option.label | translate }}</ng-template>
        </p-selectbutton>
    </div>

    <p-table
        [value]="rows()"
        [loading]="loading()"
        [paginator]="rows().length > 25"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        [rowHover]="true"
        dataKey="_id">
        <ng-template #header>
            <tr>
                <th>{{ 'NAME' | translate }}</th>
                <th>{{ 'CONTACT' | translate }}</th>
                <th class="text-right">{{ 'VENUES' | translate }}</th>
                <th></th>
                <th class="w-10"></th>
            </tr>
        </ng-template>
        <ng-template #body let-customer>
            <tr class="cursor-pointer" (click)="open(customer)">
                <td>
                    <div class="flex items-center gap-3">
                        <span
                            class="size-9 shrink-0 rounded-full flex items-center justify-center bg-concern-accent text-concern-accent-title text-sm font-semibold">
                            {{ initials(customer) }}
                        </span>
                        <div class="flex flex-col min-w-0">
                            <span class="font-medium text-text truncate">{{ displayName(customer) }}</span>
                            @if (customer.isCompany && customer.companyName) {
                                <span class="text-xs text-text-muted truncate">{{ customer.companyName }}</span>
                            }
                        </div>
                    </div>
                </td>
                <td>
                    <div class="flex flex-col text-sm min-w-0">
                        <span class="text-text-2 truncate">{{ customer.email }}</span>
                        <span class="text-text-muted">{{ customer.phone }}</span>
                    </div>
                </td>
                <td class="text-right font-medium">{{ customer.venueCount }}</td>
                <td>
                    <div class="flex flex-wrap gap-1">
                        @if (customer.blackListed) {
                            <p-tag [value]="'BLOCKED' | translate" severity="danger" />
                        }
                        @if (customer.excludeCrm) {
                            <p-tag [value]="'NO_MARKETING' | translate" severity="secondary" />
                        }
                    </div>
                </td>
                <td class="text-text-muted"><i class="ph ph-caret-right"></i></td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="5">
                    <fb-empty-state
                        icon="ph-address-book"
                        [title]="(search() || filter() !== 'ALL' ? 'NO_CUSTOMERS_MATCH' : 'NO_CUSTOMERS_YET') | translate"
                        [text]="(search() || filter() !== 'ALL' ? 'NO_CUSTOMERS_MATCH_TEXT' : 'NO_CUSTOMERS_YET_TEXT') | translate" />
                </td>
            </tr>
        </ng-template>
    </p-table>
</section>
